// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falN: CreateIconOptions = {
  "displayName": "FALN",
  "viewBox": "0, 0, 384, 512",
  "d": "M10.5 33c6.3-2.3 13.4-.4 17.7 4.7L352 420.3 352 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 6.7-4.2 12.7-10.5 15s-13.4 .4-17.7-4.7L32 91.7 32 464c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 48c0-6.7 4.2-12.7 10.5-15z"
};
